import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BreadcrumbService } from './breadcrumb.service';

@Component({
    selector: 'sas-breadcrumb',
    imports: [RouterLink],
    templateUrl: './sas-breadcrumb.component.html',
    styleUrl: './sas-breadcrumb.component.scss',
})
export class SasBreadcrumbComponent {
    private readonly breadcrumbService = inject(BreadcrumbService);

    protected readonly items   = this.breadcrumbService.items;
    protected readonly visible = this.breadcrumbService.visible;
}
